import EllipsisTextTooltip from 'components/EllipsisTextTooltip';
import { AdditionalCharge } from 'store/invoice-config/types';
import { Code, Desc } from 'views/invoices/invoice-details/components/styles';

type Props = {
    charge: AdditionalCharge;
};

const AdditionalChargeLabel = ({ charge }: Props) => {
    return (
        <div
            style={{
                display: 'grid',
                gridTemplateColumns: '2fr 3fr',
                gap: 8,
                justifyItems: 'space-between',
                width: '100%',
            }}
        >
            <EllipsisTextTooltip tooltipTitle={charge.productCode}>
                <Code>{charge.productCode}</Code>
            </EllipsisTextTooltip>
            <EllipsisTextTooltip tooltipTitle={charge.description}>
                <Desc>{charge.description}</Desc>
            </EllipsisTextTooltip>
        </div>
    );
};

export default AdditionalChargeLabel;
